export const NFT_STORAGE_KEY = process.env.VUE_APP_NFT_STORAGE_KEY || "";
export const INFURA_ID = process.env.VUE_APP_INFURA_ID || "";
export const INFURA_KEY = process.env.VUE_APP_INFURA_KEY || "";
export const FORTMATIC_KEY = process.env.VUE_APP_FORTMATIC_KEY || "";
